import { useMemo } from 'react';
import {
  MAX_SEARCH_ITEMS,
  MAX_SEARCH_LENGTH,
  MIN_SEARCH_LENGTH,
} from '~/scripts/constants';
import { isEmptySearch } from '~/scripts/isEmptySearch';
import type { Searches } from '~/types/searches';

export default function useSearchFormatErrors(
  search: Searches.StoredSearchObject | undefined | null
): string[] {
  return useMemo(() => {
    const errors: string[] = [];

    if (!search) {
      return errors;
    }
    if (isEmptySearch(search)) {
      return errors;
    }

    const total = Object.keys(search).reduce((count, operator) => {
      search[operator as keyof Searches.SearchObject].forEach((item) => {
        if (item.type === 'code') {
          if (
            item.value.length < MIN_SEARCH_LENGTH ||
            item.value.length > MAX_SEARCH_LENGTH
          ) {
            errors.push(
              `Code searches must be between ${MIN_SEARCH_LENGTH} and ${MAX_SEARCH_LENGTH} characters`
            );
          }
        }
      });
      return count + search[operator as keyof Searches.SearchObject].length;
    }, 0);

    if (total > MAX_SEARCH_ITEMS) {
      errors.push(
        `A maximum of ${MAX_SEARCH_ITEMS} search terms can be included at once`
      );
    }

    if (search.none.length && !search.any.length && !search.all.length) {
      errors.push(
        `At least one inclusion search field is required (All or Any)`
      );
    }

    return errors;
  }, [search]);
}
